import useQueryParams from 'hooks/useQueryParams'
import { useCallback } from 'react'

export default () => {
  const { addQueryParam } = useQueryParams()

  /**
   * A method to switch a patient view.
   * @param {string} view - The ID of the view to switch to. see `PatientSidebarItemKeys`.
   */
  const selectPatientView = useCallback(
    (view = '') => {
      addQueryParam({ patientView: view })
    },
    [addQueryParam]
  )

  return { selectPatientView }
}
